const nestDrops = {
  "Tables": [
    {
      "TableID": "18409618161865180574",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 158,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 170,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1186,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1151,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1169,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1183,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18409617062353552363",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 160,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 169,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1229,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1137,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1178,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1194,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18409615962841924152",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 159,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 170,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1155,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1141,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1142,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1164,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18409623659423321629",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 161,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 171,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1199,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1227,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1174,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1170,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18409622559911693418",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 162,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 172,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1199,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1147,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1179,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1164,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18409621460400065207",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 159,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 170,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1163,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1213,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1168,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1212,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18409620360888436996",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 88,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 89,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 1146,
          "Values": [
            100,
            100,
            0,
            0,
            100
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 1214,
          "Values": [
            0,
            100,
            100,
            100,
            0
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1228,
          "Values": [
            0,
            0,
            100,
            100,
            0
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1134,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1175,
          "Values": [
            0,
            0,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1133,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18409610465283783097",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 159,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 172,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 90,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 91,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 583,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1135,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1215,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1136,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18409609365772154886",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 162,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 173,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 90,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 91,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1217,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1224,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1206,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1140,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408627501888351688",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 157,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 171,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 90,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 91,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1193,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1197,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1153,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1205,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408628601399979899",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 161,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 171,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 90,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 91,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 583,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1200,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1182,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1161,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408629700911608110",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 162,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 169,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 90,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 91,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 583,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1209,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1204,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1176,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408630800423236321",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 163,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 170,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1149,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1156,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1159,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408631899934864532",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 157,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 171,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1149,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1131,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1150,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408632999446492743",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 160,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 172,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1157,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1143,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1130,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408634098958120954",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 159,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 173,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1172,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1165,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1160,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1144,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408635198469749165",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 160,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 174,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1225,
          "Values": [
            100,
            100,
            0,
            100,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1223,
          "Values": [
            0,
            100,
            100,
            0,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1198,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1167,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408618705795326000",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 161,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 169,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1162,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1188,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1211,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18408619805306954211",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 162,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 170,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 86,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1222,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1142,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1212,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411567595981620227",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 163,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 171,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 86,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1220,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1147,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1164,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411566496469992016",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 157,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 172,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1132,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1166,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1173,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411569795004876649",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 158,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 173,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1132,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1218,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1145,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411568695493248438",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 159,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 174,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1218,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1171,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1185,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411571994028133071",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 160,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 169,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 90,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 91,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 583,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1187,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1152,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1221,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411570894516504860",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 161,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 170,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 90,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 91,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 583,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1184,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1208,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1203,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411574193051389493",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 158,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 170,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1216,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1138,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1139,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411573093539761282",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 159,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 171,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1216,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1210,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1139,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411576392074645915",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 160,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 172,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1177,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1181,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1154,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18411575292563017704",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 161,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 173,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 92,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1192,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1181,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1154,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18410611020865265882",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 162,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 174,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 86,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1189,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1180,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1202,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18410612120376894093",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 163,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 169,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 86,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1195,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1207,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1201,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18410608821842009460",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 163,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 169,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 86,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1148,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1191,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1158,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18410609921353637671",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 157,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 170,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 86,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1190,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1226,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1158,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18410606622818753038",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 158,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 171,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 86,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1149,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1196,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1219,
          "Values": [
            0,
            0,
            0,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "18410607722330381249",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 158,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 171,
          "Values": [
            80,
            80,
            80,
            80,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 86,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 87,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 580,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 582,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 581,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 583,
          "Values": [
            20,
            25,
            30,
            35,
            50
          ]
        }
      ]
    },
    {
      "TableID": "14346622305966986819",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            3,
            5,
            10
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            60,
            70,
            80,
            90,
            100
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 50,
          "Values": [
            30,
            40,
            50,
            70,
            90
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 50,
          "Values": [
            30,
            40,
            50,
            60,
            70
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 231,
          "Values": [
            1,
            2,
            3,
            4,
            5
          ]
        }
      ]
    },
    {
      "TableID": "7602273390206835788",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            60,
            70,
            80,
            90,
            100
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 50,
          "Values": [
            20,
            30,
            40,
            50,
            60
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1579,
          "Values": [
            0,
            0,
            50,
            60,
            70
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 94,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 94,
          "Values": [
            80,
            80,
            80,
            90,
            100
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 94,
          "Values": [
            50,
            50,
            60,
            80,
            100
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 94,
          "Values": [
            30,
            30,
            40,
            70,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 94,
          "Values": [
            30,
            30,
            40,
            60,
            90
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 94,
          "Values": [
            10,
            10,
            20,
            50,
            80
          ]
        }
      ]
    },
    {
      "TableID": "7916242176647440136",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            5,
            15,
            30
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 796,
          "Values": [
            0,
            0,
            1,
            3,
            5
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 92,
          "Values": [
            80,
            80,
            80,
            90,
            100
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 581,
          "Values": [
            20,
            20,
            30,
            50,
            70
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 32,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 51,
          "Values": [
            0,
            0,
            50,
            65,
            80
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 53,
          "Values": [
            0,
            0,
            5,
            10,
            15
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 11,
          "Values": [
            0,
            0,
            60,
            80,
            100
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 576,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 50,
          "Values": [
            0,
            0,
            100,
            100,
            100
          ]
        }
      ]
    },
    {
      "TableID": "12844586877301738270",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 796,
          "Values": [
            0,
            0,
            0,
            1,
            1
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 50,
          "Values": [
            80,
            80,
            80,
            80,
            85
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 50,
          "Values": [
            25,
            25,
            55,
            55,
            75
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 50,
          "Values": [
            15,
            15,
            35,
            45,
            65
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 50,
          "Values": [
            0,
            0,
            25,
            35,
            55
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 50,
          "Values": [
            0,
            0,
            20,
            25,
            45
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 50,
          "Values": [
            0,
            0,
            0,
            15,
            35
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 50,
          "Values": [
            0,
            0,
            0,
            5,
            25
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 50,
          "Values": [
            0,
            0,
            0,
            0,
            15
          ]
        }
      ]
    },
    {
      "TableID": "6452152796448791288",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            25,
            25,
            25,
            25,
            25
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 1253,
          "Values": [
            50,
            50,
            50,
            60,
            70
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 1254,
          "Values": [
            0,
            0,
            1,
            1,
            1
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 134,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 591,
          "Values": [
            30,
            50,
            60,
            70,
            80
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 708,
          "Values": [
            30,
            50,
            60,
            70,
            80
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 709,
          "Values": [
            30,
            50,
            60,
            70,
            80
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 852,
          "Values": [
            30,
            50,
            60,
            70,
            80
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 37,
          "Values": [
            70,
            70,
            70,
            85,
            100
          ]
        }
      ]
    },
    {
      "TableID": "10631011222550071978",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 106,
          "Values": [
            80,
            80,
            80,
            80,
            100
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 106,
          "Values": [
            40,
            40,
            60,
            80,
            100
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 106,
          "Values": [
            20,
            40,
            40,
            60,
            80
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 106,
          "Values": [
            20,
            20,
            20,
            40,
            60
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 258,
          "Values": [
            10,
            10,
            20,
            30,
            40
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 1105,
          "Values": [
            10,
            10,
            20,
            30,
            40
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 1106,
          "Values": [
            10,
            10,
            20,
            30,
            40
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 1107,
          "Values": [
            10,
            10,
            20,
            30,
            40
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 1108,
          "Values": [
            10,
            10,
            20,
            30,
            40
          ]
        }
      ]
    },
    {
      "TableID": "10750893088316477363",
      "Entries": [
        {
          "EntryID": 0,
          "ItemID": 795,
          "Values": [
            0,
            0,
            1,
            2,
            3
          ]
        },
        {
          "EntryID": 1,
          "ItemID": 50,
          "Values": [
            100,
            100,
            100,
            100,
            100
          ]
        },
        {
          "EntryID": 2,
          "ItemID": 50,
          "Values": [
            25,
            35,
            55,
            100,
            100
          ]
        },
        {
          "EntryID": 3,
          "ItemID": 50,
          "Values": [
            25,
            35,
            35,
            55,
            100
          ]
        },
        {
          "EntryID": 4,
          "ItemID": 50,
          "Values": [
            10,
            10,
            15,
            35,
            55
          ]
        },
        {
          "EntryID": 5,
          "ItemID": 84,
          "Values": [
            20,
            25,
            40,
            50,
            70
          ]
        },
        {
          "EntryID": 6,
          "ItemID": 83,
          "Values": [
            20,
            25,
            40,
            50,
            70
          ]
        },
        {
          "EntryID": 7,
          "ItemID": 82,
          "Values": [
            20,
            25,
            40,
            50,
            70
          ]
        },
        {
          "EntryID": 8,
          "ItemID": 85,
          "Values": [
            20,
            25,
            40,
            50,
            70
          ]
        },
        {
          "EntryID": 9,
          "ItemID": 849,
          "Values": [
            20,
            25,
            40,
            50,
            70
          ]
        }
      ]
    }
  ]
};

export default nestDrops;